import { IconType } from '@repo/ui/components';
import { TCommonTypes } from './common';

export type TMenuItem = {
  context?: any;
  icon: IconType;
  text: string;
  onSelect(context?: any): void;
};

export enum Alignment {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export type MenuIconSize = {
  width: number;
  height: number;
};

export type TMenuProps = {
  align: Alignment;
  items: TMenuItem[];
  icon: IconType;
  callback(item: TMenuItem): void;
  triggerIconSize: MenuIconSize;
  itemIconSize?: MenuIconSize;
  headerClassName?: string;
  itemClassName?: string;
} & TCommonTypes;
